module.exports = __webpack_public_path__ + "img/spezialisierungen_640.87ce21c7.webp";